module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_mar_03-cd162fef3a2799eedc8ce51ef30e265c.png";